// extracted by css-extract-rspack-plugin
export default {"scrollContainer":"sxo1wkwEPYM5SR16","wrapper":"mHrIDzyqZHc1ZZfT","fade":"mmdwxTJcWN0i6d7R"};